import {CTAPIConfiguration} from './utils/configuration';
import {RequestHelper} from './utils/request';
import {InsuranceRestInterface} from './interfaces/_insurance.rest';
import {Insurance} from '../models/interfaces/_insurance.model';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

export class InsuranceRest implements InsuranceRestInterface {

    private configuration: CTAPIConfiguration;
    private requestHelper: RequestHelper;

    constructor(configuration: CTAPIConfiguration) {
        this.configuration = configuration;
        this.requestHelper = new RequestHelper(configuration);
    }

    /**
     * Request for insurances list.
     */
    getInsurances(nCustID: number, nDivID, sEnvCode): Observable<Insurance[]> {
        return this.requestHelper.request({data: {nCustID, nDivID, sEnvCode}}, this.configuration.insurance.get,
            this.configuration.httpClient).pipe(
            map((response) => {
                return response.result ? response.result.insurances : [];
            })
        );
    }

    /**
     * Request for costs objects.
     */
    getCostObjects(nDivID, sEnvCode, sCostObjectFull) {
        return this.requestHelper.request({
                data:
                    {
                        nDivID,
                        sEnvCode,
                        sCostObjectFull
                    }
            }, this.configuration.insurance.getCosts,
            this.configuration.httpClient).pipe(map((response) => {
            return response.result ? response.result.costObjects : [];
        }));
    }

    /**
     * Request for costs objects.
     */
    linkFilesToOrder(filesToLink, nDivID, sEnvCode) {
        return this.requestHelper.request({
                data:
                    {
                        nDivID,
                        sEnvCode,
                        files:
                        filesToLink
                    }
            }, this.configuration.insurance.linkFiles,
            this.configuration.httpClient).pipe(map((response) => {
            return response.result ? response.result.fileIDs : [];
        }));
    }

    /**
     * Request for costs objects.
     */
    unlinkFilesToOrder(fileID, relObj, nDivID, sEnvCode) {
        return this.requestHelper.request({
                data:
                    {
                        nDivID,
                        sEnvCode,
                        relObj,
                        fileID
                    }
            }, this.configuration.insurance.unlinkFiles,
            this.configuration.httpClient).pipe(map((response) => {
            return response ? response : {};
        }));
    }

}
